import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "disabled", "value", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useState } from 'react';
import { SelectOptionContext } from './context/SelectOptionContext';
import { Checkbox } from '@lmig/lmds-react-checkbox';
import classNames from 'classnames';
import { uniqueId } from '@lmig/lmds-helpers';
import { matchSelectedValue } from './utils';
export var SelectOption = function SelectOption(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    value = _ref.value,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // Uses the value as an id base if id isn't provided since value is usually passed in.
  var _useState = useState(id || value && "lmig-Select-option-".concat(value === null || value === void 0 ? void 0 : value.replaceAll(/ /g, '-')) || uniqueId('select-option')),
    _useState2 = _slicedToArray(_useState, 1),
    customID = _useState2[0];
  var _useContext = useContext(SelectOptionContext),
    _useContext$multiSele = _useContext.multiSelect,
    multiSelect = _useContext$multiSele === void 0 ? false : _useContext$multiSele,
    contextValue = _useContext.value,
    _onClick = _useContext.onClick,
    activeOptionID = _useContext.activeOptionID;
  if (!multiSelect) {
    return /*#__PURE__*/React.createElement("option", _extends({
      id: id,
      className: className,
      disabled: disabled,
      value: value
    }, otherProps), children);
  }
  var isSelected = contextValue.some(matchSelectedValue(value));
  var disabledProps = disabled ? {
    'aria-disabled': 'true'
  } : {
    onClick: function onClick(event) {
      return _onClick(event, value, children, !isSelected);
    }
  };
  var liClassNames = classNames('lmig-Select-option', className, {
    'lmig-Select-option--keyHover': activeOptionID && activeOptionID === customID
  }, {
    'lmig-Select-option--disabled': disabled
  });
  return /*#__PURE__*/React.createElement("li", _extends({
    id: customID,
    className: liClassNames,
    tabIndex: -1,
    role: "option",
    "aria-selected": isSelected
  }, otherProps, disabledProps), /*#__PURE__*/React.createElement(Checkbox, {
    checked: isSelected,
    disabled: disabled,
    value: value,
    labelVisual: children,
    className: "lmig-Select-option-checkbox",
    readOnly: true,
    hidden: true
  }));
};
SelectOption.propTypes = {
  /** Add an optional ID to this element: `<option>`. */id: _pt.string,
  /** Add custom classes to this element: `<option>`. */className: _pt.string,
  /**
     * Disable this select option.
     * @default false
     * */
  disabled: _pt.bool,
  /** Populates this value in the parent Select element. */value: _pt.string,
  /** Only text should be passed as children. Children are rendered in this element: `<option>` */children: _pt.node
};